import { Box } from '@mui/material'
import type { TabPanelProps } from './types'

export const TabPanel = (props: TabPanelProps) => {
  const { children, value, id, ...rest } = props

  return (
    <>{value === id && <Box sx={{ padding: '16px 8px' }}>{children}</Box>}</>
  )
}
